import { Link } from "react-router-dom";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import ServiceNav from "../../components/ServiceNav";

function HealthInsurance() {
  return (
    <>
      <Header />
      <main>
        <section class="tp-hero-area p-relative">
          <div class="tp-hero-wrapper-slider">
            <div class="swiper-container">
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide pt-20 pb-150 tp-hero-bg-image"
                  data-bg-color="#20536d"
                >
                  <img
                    class="tp-hero-bg"
                    src="../assets/images/banner-bg.png"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="tp-service-details-area pt-120 pb-120">
          <div class="container">
            <div class="row">
              <div class="col-lg-4">
                <div class="tp-service-widget">
                  <div class="tp-service-widget-item mb-40">
                    <ServiceNav activePath="/HealthInsurance" />
                  </div>
                </div>
              </div>
              <div class="col-lg-8">
                <div class="tp-service-details-wrapper">
                  <h3 class="tp-service-details-title">
                    Affordable Health Insurance for Individuals & Families
                  </h3>

                  <div class="tp-postbox-list mr-40">
                    <p>
                      Finding the right health insurance can feel overwhelming —
                      but it doesn’t have to be.
                    </p>
                    <p>
                      At <strong>Kubera Financial Services</strong>, we help
                      individuals, families, self-employed professionals, and
                      small business owners navigate their health coverage
                      options with confidence.
                    </p>
                  </div>

                  <div class="tp-postbox-list-wrapper">
                    <div class="tp-postbox-list mr-40">
                      <h2 class="tp-postbox-list-title-1">
                        We assist clients with:
                      </h2>
                      <h4 class="tp-postbox-list-title">
                        <i class="fa-regular fa-check"></i> ACA Marketplace
                        Plans
                      </h4>
                      <h4 class="tp-postbox-list-title">
                        <i class="fa-regular fa-check"></i> Affordable Care Act
                        (Obamacare) Coverage
                      </h4>
                      <h4 class="tp-postbox-list-title">
                        <i class="fa-regular fa-check"></i> Individual & Family
                        Health Plans
                      </h4>
                      <h4 class="tp-postbox-list-title">
                        <i class="fa-regular fa-check"></i> Subsidy Eligibility
                        Assistance
                      </h4>
                      <h4 class="tp-postbox-list-title">
                        <i class="fa-regular fa-check"></i> Special Enrollment
                        Guidance
                      </h4>
                      <h4 class="tp-postbox-list-title">
                        <i class="fa-regular fa-check"></i> Dental & Vision
                        Options
                      </h4>
                      <h4 class="tp-postbox-list-title">
                        <i class="fa-regular fa-check"></i> Supplemental
                        Coverage
                      </h4>
                    </div>
                  </div>

                  <div class="tp-service-details-thumb">
                    <img src="../assets/images/s1.jpeg" alt="" />
                  </div>

                  <div class="tp-postbox-list-wrapper">
                    <div class="tp-postbox-list mr-40">
                      <h2 class="tp-postbox-list-title-1">
                        Need Affordable Coverage?
                      </h2>
                      <p>
                        Many individuals qualify for premium tax credits that
                        can significantly reduce monthly premiums. Our licensed
                        agents help you understand your eligibility and compare
                        plans based on your doctors, prescriptions, and budget.
                      </p>
                    </div>
                  </div>

                  <div class="tp-service-details-box-2 tp-service-details-box-4 d-flex mb-40">
                    <div class="tp-service-details-box-content mr-30">
                      <h3 class="tp-service-details-subtitle-2">Who We Help</h3>
                      <h4 class="tp-service-details-subtitle-3">
                        <i class="fa-regular fa-check"></i> Self-employed
                        individuals
                      </h4>
                      <h4 class="tp-service-details-subtitle-3">
                        <i class="fa-regular fa-check"></i> Gig workers &
                        freelancers
                      </h4>
                      <h4 class="tp-service-details-subtitle-3">
                        <i class="fa-regular fa-check"></i> Families without
                        employer coverage
                      </h4>
                      <h4 class="tp-service-details-subtitle-3">
                        <i class="fa-regular fa-check"></i> Early retirees
                      </h4>
                      <h4 class="tp-service-details-subtitle-3">
                        <i class="fa-regular fa-check"></i> Individuals losing
                        employer insurance
                      </h4>
                      <h4 class="tp-service-details-subtitle-3">
                        <i class="fa-regular fa-check"></i> People moving from
                        Medicaid coverage
                      </h4>
                    </div>
                  </div>

                  <div class="tp-postbox-list-wrapper">
                    <div class="tp-postbox-list mr-40">
                      <h2 class="tp-postbox-list-title-1">
                        Why Choose Kubera Financial Services?
                      </h2>
                      <p>
                        We believe health insurance should be understandable,
                        affordable, and personalized. Our goal is to educate you
                        on your options so you can make the best decision for
                        yourself and your family.
                      </p>
                    </div>
                  </div>

                  <div class="tp-service-details-box-2 tp-service-details-box-4 d-flex mb-40">
                    <div class="tp-service-details-box-content mr-30">
                      <h3 class="tp-service-details-subtitle-2">
                        Common Questions We Help Answer
                      </h3>
                      <h4 class="tp-service-details-subtitle-3">
                        <i class="fa-regular fa-check"></i> Do I qualify for
                        Marketplace subsidies?
                      </h4>
                      <h4 class="tp-service-details-subtitle-3">
                        <i class="fa-regular fa-check"></i> Which plan works
                        best for my doctors?
                      </h4>
                      <h4 class="tp-service-details-subtitle-3">
                        <i class="fa-regular fa-check"></i> What is the
                        difference between HMO and PPO?
                      </h4>
                      <h4 class="tp-service-details-subtitle-3">
                        <i class="fa-regular fa-check"></i> Can I enroll outside
                        Open Enrollment?
                      </h4>
                      <h4 class="tp-service-details-subtitle-3">
                        <i class="fa-regular fa-check"></i> How much coverage do
                        I actually need?
                      </h4>
                    </div>
                  </div>

                  <div class="tp-service-bg tp-service-details-box-2 tp-service-details-box-4 d-flex mb-40">
                    <div class="tp-service-details-box-content mr-30">
                      <h3 class="tp-service-details-subtitle-2">
                        We offer free consultation
                      </h3>
                      <p>
                        Schedule your free consultation today and let us help
                        you find the right coverage.
                      </p>

                      <h6>Please reach us for free consultation!</h6>
                      <Link class="tp-btn-service" to="/ContactUs">
                        Contact Us
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
export default HealthInsurance;
